import { useState, useEffect } from "react";
import {
  Grid,
  FormControl,
  Select,
  MenuItem,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import dashboardStyles from "./style";
import "react-dates/initialize";
import RemoveIcon from "@mui/icons-material/Remove";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";

const DashboardHeadear = ({
  allRestaurants,
  restVal,
  setRestVal,
  dateValues,
  setDateValues,
  handleSubmit,
  handleReset,
  type,
  getData,
}) => {
  const classes = dashboardStyles();
  const [focus, setFocus] = useState(null);

  const handleChangeRest = (event) => {
    setRestVal(event.target.value);
    let params = {};
    // getData(params, event.target.value);
  };

  const handleOnDateChange = (startDate, endDate) => {
    let start = startDate.startDate;
    let end = startDate.endDate;
    setDateValues({
      startDate: start,
      endDate: end,
    });
  };

  return (
    <div style={{ marginBottom: "20px" }}>
      <Grid
        container
        spacing={2}
        style={{ justifyContent: type === "dashboard" ? "space-between" : "" }}
      >
        {type === "order" && (
          <Grid item xs={12} sm={6} md={2}>
            <FormControl
              className={classes.durationSelect}
              size="small"
              fullWidth
            >
              <Select displayEmpty value={restVal} onChange={handleChangeRest}>
                <MenuItem value="">Select Restaurant</MenuItem>
                {allRestaurants.map((item) => {
                  return <MenuItem value={item._id}>{item.name}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Grid>
        )}

        {/* <Grid item xs={12} md={2}>
          <FormControl
            className={classes.durationSelect}
            size="small"
            fullWidth
          >
            <Select displayEmpty value={duration} onChange={handleChange}>
              <MenuItem value="daily">Daily</MenuItem>
              <MenuItem value="weekly">Weekly</MenuItem>
              <MenuItem value="monthly">Monthly</MenuItem>
              <MenuItem value="">All</MenuItem>
            </Select>
          </FormControl>
        </Grid> */}
        <Grid item xs={12} sm={6} md={6}>
          <DateRangePicker
            isOutsideRange={() => false}
            startDatePlaceholderText="Start Date"
            startDate={dateValues.startDate}
            onDatesChange={handleOnDateChange}
            endDatePlaceholderText="End Date"
            endDate={dateValues.endDate}
            numberOfMonths={2}
            displayFormat="DD-MM-YYYY"
            showClearDates={true}
            focusedInput={focus}
            onFocusChange={(focus) => setFocus(focus)}
            startDateId="startDateMookh"
            endDateId="endDateMookh"
            minimumNights={0}
            small
            showDefaultInputIcon={false}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="contained"
            className={classes.loginBtn}
            size="small"
            // onClick={handleSubmit}
            disableRipple
            sx={{
              width: "20% !important",
              marginRight: "10px",
            }}
          >
            <Typography className={classes.loginBtnText}>Submit</Typography>
          </Button>
          <Button
            variant="contained"
            className={classes.loginBtn}
            size="small"
            // onClick={handleReset}
            disableRipple
            sx={{
              width: "20% !important",
            }}
          >
            <Typography className={classes.loginBtnText}>Reset</Typography>
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default DashboardHeadear;
